import React from "react";
import { FormattedMessage } from "react-intl";
import { Grid, Text } from "@chakra-ui/react";
import PaymentMethod from "./PaymentMethod";
import { AMOUNT_OUTSIDE_LIMITS_REASON_CODES, getIfAmountIsWithinLimitsForPM } from "./utils";

const PaymentMethodList = ({
  showMenu = true,
  paymentMethods,
  selectedPaymentMethodId,
  onSelect,
  onPayoutOptionSelect,
  onUpdate,
  disabled,
  isPayout,
  pmidErrorList = [],
  transactionLimits,
  amountToCheck,
}) => {
  return (
    <Grid gridGap="4" py="4">
      {paymentMethods.map((pm) => {
        const pmErrorOccured = pmidErrorList && pmidErrorList.includes(pm.id);
        const { amountIsWithinLimits, reasonCode } = getIfAmountIsWithinLimitsForPM({ pm, txnLimits: transactionLimits, amountToCheck });
        const isDisabled = disabled || pmErrorOccured || !amountIsWithinLimits;
        let disabledUserMessage = null;
        if (pmErrorOccured) {
          disabledUserMessage = (
            <Text as="i" color="errorText" fontSize="sm">
              <FormattedMessage defaultMessage="Payment method error, please try another." description="error message" />
            </Text>
          );
        } else if (!amountIsWithinLimits) {
          let reasonMsg = <FormattedMessage defaultMessage="Unknown error" description="label" />; // unlikely default
          if (reasonCode === AMOUNT_OUTSIDE_LIMITS_REASON_CODES.ABOVE_MAX_AMOUNT) {
            reasonMsg = <FormattedMessage defaultMessage="Amount required exceeds limit for payment method." description="error message" />;
          } else if (reasonCode === AMOUNT_OUTSIDE_LIMITS_REASON_CODES.BELOW_MIN_AMOUNT) {
            reasonMsg = <FormattedMessage defaultMessage="Amount is less than minimum required for payment method." description="error message" />;
          }
          disabledUserMessage = (
            <Text as="i" color="errorText" fontSize="sm">
              {reasonMsg}
            </Text>
          );
        }
        return (
          <PaymentMethod
            isSelected={selectedPaymentMethodId === pm.id}
            key={`payment-method-${pm.id}`}
            paymentMethod={pm}
            onSelect={onSelect}
            onPayoutOptionSelect={onPayoutOptionSelect}
            onUpdate={onUpdate}
            showMenu={showMenu}
            disabled={isDisabled}
            disabledUserMessage={disabledUserMessage}
            isPayout={isPayout}
            cursor={onSelect && "pointer"}
            transition="background-color 0.2s ease-out 10ms"
            _hover={{
              bgColor: "lightBackground",
              borderColor: "integrator.300",
            }}
          />
        );
      })}
    </Grid>
  );
};

export default PaymentMethodList;
